module.exports = __webpack_public_path__ + "static/media/meta.392a7451.svg";